import cx from 'classnames';

import { useIntl } from 'react-intl';

import s from './Rating.css';

type Props = {
    className?: string;
    value: number;
};

export const Rating = ({ className, value }: Props): JSX.Element => {
    const { formatMessage } = useIntl();
    return (
        <span
            className={cx(s.container, className)}
            data-testid={`rating-${value}`}
            role="img"
            aria-label={formatMessage(
                { id: 'rating.accessibility.label' },
                {
                    rating: value,
                    max: 5,
                },
            )}
        >
            {[0, 1, 2, 3, 4].map((i) => (
                <span key={i} className={i < value ? s.full : s.empty} aria-hidden="true" />
            ))}
        </span>
    );
};
